var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warning-message__card"},[_c('div',{staticClass:"warning-message__header"},[_c('div',{staticClass:"warning-message__icon-container"},[_c('div',{staticClass:"icon-svg__container"},[_c('WarningIcon',{staticClass:"warning-message__icon"})],1)])]),_c('div',{staticClass:"warning-message__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }